export default "__VITE_PUBLIC_ASSET__cd004395__"